import { Component, OnInit,Input, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PolicyXML, State, Operation, Feature } from 'src/app/models/common'
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-configure-screens-modal',
  templateUrl: './configure-screens-modal.component.html',
  styleUrls: ['./configure-screens-modal.component.scss']
})
export class ConfigureScreensModalComponent implements OnInit {
  @Input() public Content: any;
  selectedStates: State[];
  selectedScreens: Feature[];
  selectedOperations: Operation[];
  //policy: PolicyXML;
  oldpolicy: any;
  Currenttab: any;
  CurrentTabIndex: any;
  isOperationsRequired: boolean=false;
  action: Subject<any> = new Subject();
  public event: EventEmitter<any> = new EventEmitter();
  HasChangesDone: boolean = false;
  draftConfigureForm = new UntypedFormGroup({
    configSubmit: new UntypedFormControl(true),
    configRoute: new UntypedFormControl(false),
    configReject: new UntypedFormControl(false),
    configReturn: new UntypedFormControl(false),
    configOnHold: new UntypedFormControl(false),
    configDiscard: new UntypedFormControl(true),
    configWithdrawn: new UntypedFormControl(false)
  })
  constructor(public modalRef: NgbActiveModal, private commonService: CommonService) { }

  ngOnInit() {
     ;
    this.oldpolicy = JSON.parse(JSON.stringify(this.Content.policy));
    this.CurrentTabIndex = "tab0";
    this.selectedStates = [];
    this.selectedScreens = [];
    let len = this.oldpolicy.States.length;
    this.oldpolicy.States = this.oldpolicy.States.sort((a, b) => a.SNO - b.SNO);
    for (var i = 0; i < len; i++) {
      if (this.oldpolicy.States[i].ISCHECKED) {
        this.selectedScreens = [];
        let slen=0;
        if(this.oldpolicy.States[i].Features!=null)
        {
          slen = this.oldpolicy.States[i].Features.length;

        }
        for (var j = 0; j < slen; j++) {
          if (this.oldpolicy.States[i].Features[j].ISCHECKED)
            this.selectedScreens.push(this.oldpolicy.States[i].Features[j]);
        }
        this.selectedScreens = this.selectedScreens.sort((a, b) => a.Sno - b.Sno);

        this.oldpolicy.States[i].Features = JSON.parse(JSON.stringify(this.selectedScreens));
        this.selectedStates.push(JSON.parse(JSON.stringify(this.oldpolicy.States[i])));
      }
    }
     ;
    this.Currenttab = this.selectedStates[0];
    len = this.Content.policy.Operations.length;

    this.selectedOperations = [];
    for (var i = 0; i < len; i++) {
      if (!this.Content.policy.Operations[i].IsDeleted != undefined && !this.Content.policy.Operations[i].IsDeleted) {
        this.selectedOperations.push(this.Content.policy.Operations[i]);
      }
    }
  }

  IsChecked(operation, typeofUser) {
    if (typeofUser == "E") {
      if (this.Currenttab.ExternalUsers != null && this.Currenttab.ExternalUsers != undefined) {
        var oldOperation = this.Currenttab.ExternalUsers.filter(x => x.Code == operation.Code)[0];
        if (oldOperation == null || oldOperation == undefined) {
          return false;
        }
        else {
          return true;
        }
      }

    }
    else {
      if (this.Currenttab.InternalUsers != null && this.Currenttab.InternalUsers != undefined) {
        var oldOperation = this.Currenttab.InternalUsers.filter(x => x.Code == operation.Code)[0];
        if (oldOperation == null || oldOperation == undefined) {
          return false;
        }
        else {
          return true;
        }
      }
    }
  }

  CheckChanged(type: string, value: boolean, operation: Operation) {
    if (!value) {
      operation.ISCHECKED = true;
    }
    else {
      if (type === "E") {
        if (!operation.Internal)
          operation.ISCHECKED = false;
      }
      else {
        if (!operation.External)
          operation.ISCHECKED = false;
      }
    }
  }

  StateClick(operation: Operation) {
    operation.ISCHECKED = !operation.ISCHECKED;
  }

  SaveOperations(operation, targetUser) {

    //if (targetUser == "E") {
    //  if (this.Currenttab.ExternalUsers == null || this.Currenttab.ExternalUsers == undefined) {
    //    this.Currenttab.ExternalUsers = [];
    //  }
    //  var oldOperation = this.Currenttab.ExternalUsers.filter(x => x.Code == operation.Code)[0];
    //  if (oldOperation == null || oldOperation == undefined) {
    //    operation["ISCHECKED"] = true;
    //    this.Currenttab.ExternalUsers.push(operation);
    //  }
    //  else {
    //    if (this.Currenttab.ExternalUsers.indexOf(operation) > -1) {
    //      let index = this.Currenttab.ExternalUsers.indexOf(operation);
    //      this.Currenttab.ExternalUsers.splice(operation, index);
    //    }
    //  }
    //}
    //else {
    //  if (this.Currenttab.InternalUsers == null || this.Currenttab.InternalUsers == undefined) {
    //    this.Currenttab.InternalUsers = [];
    //  }
    //  var oldOperation = this.Currenttab.InternalUsers.filter(x => x.Code == operation.Code)[0];
    //  if (oldOperation == null || oldOperation == undefined) {
    //    operation["ISCHECKED"] = true;
    //    this.Currenttab.InternalUsers.push(operation);
    //  }
    //  else {
    //    if (this.Currenttab.InternalUsers.indexOf(operation) > -1) {
    //      let index = this.Currenttab.InternalUsers.indexOf(operation);
    //      this.Currenttab.InternalUsers.splice(operation, index);
    //    }
    //  }
    //}
  }

  CurrenttabChange(tab, index) {
    this.oldpolicy.States.forEach((state) => {
      if (this.Currenttab.STATUSCODE == state.STATUSCODE) {
          ;
        state.Features.forEach((screen) => {
          var currentFeature = this.Currenttab.Features.filter((item) => {
            return item.Code == screen.Code;
          })[0];
          if (currentFeature != undefined && currentFeature != null) {
            screen.ExternalUser = currentFeature.ExternalUser;
            screen.InternalUser = currentFeature.InternalUser;
          }
        });
      }
    });
    this.CurrentTabIndex = "tab" + index;
    this.Currenttab = tab;
  }

  SaveConfig() {
    this.oldpolicy.States.forEach((state) => {
    //    ;
      if (this.Currenttab.STATUSCODE == state.STATUSCODE) {
        state.Features.forEach((screen) => {
          var currentFeature = this.Currenttab.Features.filter((item) => {
            return item.Code == screen.Code;
          })[0];
          if (currentFeature != undefined && currentFeature != null) {
            screen.ExternalUser = currentFeature.ExternalUser;
            screen.InternalUser = currentFeature.InternalUser;
          }
        });
      }
    });
    let ScreenList = [];
    this.Content.policy.States.forEach((state) => {
      if(state.STATUSCODE!=9)
      {
      state.Features.forEach((screen) => {
        let oldState: any = this.oldpolicy.States.filter((tempState) => {
          return tempState.STATUSCODE == state.STATUSCODE;
        })[0];
        if (oldState != undefined && oldState != null) {
          var currentFeature = oldState.Features.filter((item) => {
            return item.Code == screen.Code;
          })[0];
          if (currentFeature != undefined && currentFeature != null) {
            screen.ExternalUser = currentFeature.ExternalUser;
            screen.InternalUser = currentFeature.InternalUser;
            let IsNotConfigure = false;
            if (currentFeature.ExternalUser == "" || currentFeature.ExternalUser == null || currentFeature.ExternalUser == undefined) {
              IsNotConfigure = true;
            }
            if (currentFeature.InternalUser == "" || currentFeature.InternalUser == null || currentFeature.InternalUser == undefined) {
              IsNotConfigure = true;
            }
            if (IsNotConfigure && screen.ISCHECKED == true && state.ISCHECKED == true) {
              IsNotConfigure = false;
              if (ScreenList.indexOf(currentFeature.Name) == -1) {
                ScreenList.push(currentFeature.Name);
              }

            }
          }
        }

      });
     }
    });
    if (ScreenList.length > 0) {
      let message = "Please update workflows for below screens </br>"
      ScreenList.forEach((item) => {
        message = message + "'" + item + "'" + "</br>"
      })
      this.commonService.ValidationBanner(message);
    }
    else {
      //this.commonService.SuccessBanner("Configuration saved successfully");
     // this.action.next(this.Content.policy);
      this.modalRef.close(this.Content.policy);
    }

     ;
  }

  CancelConfig() {
    this.canExit().then(x => {
      this.modalRef.dismiss();
    });
  }
  ChangesDone() {
    this.HasChangesDone = true;
  }
  canExit() {
    if (this.HasChangesDone) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
